import { collection, getDocs, query, where } from 'firebase/firestore';
import { DEFAULT_TENANT_ID, type Category, type Menu } from '@kawai/shared';
import { db } from '../firebase.js';

const MENUS_COL = 'menus';
const CATEGORIES_COL = 'categories';

/**
 * M-37: セグメント条件「予約済みメニュー / カテゴリ」の select 用にマスタを取得する。
 *
 * Firestore Rules `menus` / `categories` は公開 read（`if true`）。セグメント抽出は
 * 自テナントのマスタだけを候補にしたいので tenantId で絞る。order / 検索は呼出側。
 */
export async function fetchMenusForTenant(
  tenantId: string = DEFAULT_TENANT_ID,
): Promise<Menu[]> {
  const snap = await getDocs(
    query(collection(db, MENUS_COL), where('tenantId', '==', tenantId)),
  );
  return snap.docs.map((d) => {
    const data = d.data() as Partial<Menu>;
    return { ...data, id: data.id ?? d.id } as Menu;
  });
}

export async function fetchCategoriesForTenant(
  tenantId: string = DEFAULT_TENANT_ID,
): Promise<Category[]> {
  const snap = await getDocs(
    query(collection(db, CATEGORIES_COL), where('tenantId', '==', tenantId)),
  );
  return snap.docs.map((d) => {
    const data = d.data() as Partial<Category>;
    return { ...data, id: data.id ?? d.id } as Category;
  });
}
